var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDowncomponent = function SvgChevronDowncomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 11 7"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF4629",
    strokeWidth: 2,
    d: "m1 1 4.5 4L10 1"
  })));
};
export default SvgChevronDowncomponent;